<label
  class="inline-flex w-full cursor-pointer items-center justify-between space-x-md rounded-3 border border-grey-200 p-md"
  [class.border-primary]="!!control?.value"
  [class.bg-president-50]="!!control?.value"
  [class.hover:border-grey-400]="!control?.value"
>
  <span class="text-base text-president-500">
    <ng-content></ng-content>
  </span>
  <input
    type="checkbox"
    [name]="controlName"
    [formControl]="control | bgoAsFormControl"
    [indeterminate]="indeterminate"
  />
</label>
